import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    iCalImportIdZodSchema,
    iCalImportSourceZodSchema,
} from "@@/shared/channels/ical/ical-import-channel";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import type { Except } from "type-fest";
import { z } from "zod";

type ICalImportJobId = Branded<string, "ICalImportJobId">;
const iCalImportIdPrefix = "ical_job__";
const {
    zodSchema: iCalImportJobIdZodSchema,
    factory: iCalImportJobIdFactory,
    assert: _isICalImport,
} = genericId<ICalImportJobId>(iCalImportIdPrefix, {
    regexMatch: /(^ical_import_.*$)/,
});

// Job specific model for iCal import channel to not mix them to much with the data model

const iCalImportChannelJobZodObject = z.object({
    _id: iCalImportJobIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("ICAL_IMPORT_CHANNEL_JOB"),
    iCalId: iCalImportIdZodSchema,
    providerId: providerIdZodSchema,
    source: iCalImportSourceZodSchema,
    targetUrl: z.string(),
    targetResource: resourceIdZodSchema,

    // Optional
    options: z
        .object({
            overwriteStartTime: z.string().optional(),
            overwriteEndTime: z.string().optional(),
        })
        .optional(),
});

type ICalImportChannelJob = z.infer<typeof iCalImportChannelJobZodObject>;

type FactoryParams = Except<
    ICalImportChannelJob,
    "_id" | "_createdAt" | "_type"
>;
const iCalImportJobFactory = (params: FactoryParams): ICalImportChannelJob => {
    return {
        ...params,
        _id: iCalImportJobIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "ICAL_IMPORT_CHANNEL_JOB",
    };
};

export { iCalImportChannelJobZodObject, iCalImportJobFactory };
export type { ICalImportChannelJob };
